// =============================================================================
// src/features/analytics/analytics-markup.ts - Shell publico da rota Analytics.
// =============================================================================

import { analyticsProvenanceUpdateLabel } from '../../data/analytics-overlay-scope';
import { buildAnalyticsProvenanceFooterMarkup } from '../../data/data-provenance';
import { analyticsLiveSource, getAnalyticsFreshness } from './analytics-live-store';
import { buildAnalyticsDetailShellMarkup } from './analytics-mention-markup';
import { buildAnalyticsFilterRailMarkup } from './analytics-filter-markup';
import { buildAnalyticsModuleViewsMarkup } from './analytics-module-markup';
import { buildAnalyticsSidebarMarkup, buildAnalyticsToolbarMarkup } from './analytics-shell-markup';

/** Monta o HTML completo da rota fullscreen Analytics. */
export function buildAnalyticsPageMarkup(): string {
  return `<div id="u-analytics-page" class="u-analytics-page" aria-hidden="true">
  <div class="u-analytics-mobile-scrim" data-analytics-filter-drawer-close hidden></div>
  <div class="u-analytics-shell">
    ${buildAnalyticsSidebarMarkup()}
    <main class="u-analytics-main" aria-label="Analytics geral de Omar Aziz">
      ${buildAnalyticsToolbarMarkup()}
      <div id="analyticsModuleViews" class="u-analytics-module-views">${buildAnalyticsModuleViewsMarkup()}</div>
      ${buildAnalyticsDetailShellMarkup()}
      <div class="u-analytics-provenance">${buildAnalyticsProvenanceFooterMarkup(analyticsLiveSource(), analyticsProvenanceUpdateLabel(getAnalyticsFreshness()))}</div>
    </main>
    ${buildAnalyticsFilterRailMarkup()}
  </div>
</div>`;
}
